<template>
  <div
    v-if="showCTA"
    class="insights-cta-banner-workforce-wrapper"
  >
    <InsightsCTABanner
      type="suspicious_behavior"
      :is-loading="isLoading"
      :hide-action-button="false"
      @hide="setDismiss"
      @submit="submitCTA"
      @close="closeCTA"
      @showDialog="openInfoPage"
    />
  </div>
</template>

<script>
import InsightsCTABanner from '~/components/insights/InsightsCTABanner.vue';

const learnMorePage = 'https://support.hubstaff.com/hubstaff-insights-add-on/#fake-activity';

export default {
  name: 'SettingsAppsURLsSuspiciousBehaviorBanner',
  components: {
    InsightsCTABanner,
  },
  data: () => ({
    localStorageHiddenKey: 'insightsWorkforceCTAHidden',
    type: 'workforce',
    showCTA: false,
    isLoading: false,
    showDialog: false,
    dismiss: false,
    url: '#',
  }),
  mounted() {
    this.showCTA = !localStorage.getItem(this.localStorageHiddenKey);

    this.modalWrapperEl = document.getElementById('insights_confirm_modal');
    this.modadEl = this.modalWrapperEl.getElementsByClassName('paid-addon-confirm')[0];
  },
  beforeDestroy() {
    const closeButton = document.querySelectorAll('#insights_confirm_modal button.close')[0];
    const cancelButton = document.querySelector('a.cancel-btn');

    closeButton.removeEventListener('click', this.onModalClose);
    cancelButton.removeEventListener('click', this.onModalClose);
  },
  methods: {
    submitCTA() {
      this.isLoading = true;

      this.mountModal();
    },
    closeCTA() {
      this.showCTA = false;

      if (this.dismiss) {
        this.hideCTA(true);
      }
    },
    setDismiss(val) {
      this.dismiss = val;
    },
    hideCTA(val) {
      localStorage.setItem(this.localStorageHiddenKey, val);
    },
    openInfoPage() {
      window.open(learnMorePage, '_blank', 'noopener noreferrer');
    },
    onModalClose() {
      document.getElementById('insights_modal_backdrop').remove();
      document.body.classList.remove('modal-open');

      document.getElementsByClassName('paid-addon-confirm')[0].style.display = 'flex';
      document.getElementsByClassName('paid-addon-confirm')[0].style.position = 'absolute';
      document.getElementsByClassName('paid-addon-confirm')[0].classList.remove('in');
      document.getElementsByClassName('paid-addon-confirm')[0].classList.add('hidden');

      this.isLoading = false;
    },
    mountModal() {
      const modalWrapperEl = document.getElementById('insights_confirm_modal');
      const modadEl = modalWrapperEl.getElementsByClassName('paid-addon-confirm')[0];

      document.body.appendChild(modalWrapperEl);

      modadEl.classList.remove('hidden');
      modadEl.classList.add('in');
      modadEl.style.display = 'block';
      modadEl.style.position = 'fixed';

      document.body.classList.add('modal-open');
      document.body.insertAdjacentHTML(
        'beforeend',
        '<div id="insights_modal_backdrop" class="modal-backdrop loader modal-stack fade in"/>',
      );

      this.$nextTick(() => {
        this.setModalListeners();
      });
    },
    setModalListeners() {
      // Changing the submit button copy on fly as this modal is taken from the billing page where we say 'continue trial'
      document.querySelector('#insights_confirm_modal a.btn.btn-primary').innerHTML = 'Add Hubstaff Insights';
      const closeButton = document.querySelectorAll('#insights_confirm_modal button.close')[0];
      const cancelButton = document.querySelector('a.cancel-btn');

      closeButton.addEventListener('click', this.onModalClose);
      cancelButton.addEventListener('click', this.onModalClose);
    },
  },
};
</script>
